import { render, staticRenderFns } from "./loan-written-off-v3.vue?vue&type=template&id=1ef97ef8&scoped=true&"
import script from "./loan-written-off-v3.vue?vue&type=script&lang=js&"
export * from "./loan-written-off-v3.vue?vue&type=script&lang=js&"
import style0 from "./loan-written-off-v3.vue?vue&type=style&index=0&id=1ef97ef8&scoped=true&lang=css&"
import style1 from "./loan-written-off-v3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef97ef8",
  null
  
)

export default component.exports